import React, { useState } from "react";
import styles from "./Header.module.css";
import { Dropdown } from "react-bootstrap";
import logowhite from "./../../public/images/logowhite.svg";
import PasswordIcon from "./../../public/images/password.svg";
import LogoutIcon from "./../../public/images/logout.svg";
import { useNavigate } from "react-router";
import { logout } from "../../api";
import { CookieUtils } from "../../axios.config";
import { useRoleFeature } from "../../context/RoleFeatureContext";
import Spinner from "../../Common/Spinner/index";

const Header = ({ role }) => {
  const navigate = useNavigate();
  const cookieUser = CookieUtils.get("username");
  const username = cookieUser || "";
  const { setRoleFeatureList } = useRoleFeature();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const onUserLogout = async () => {
    setLoading(true);
    try {
      const res = await logout({ username });
      if (res?.status === 200) {
        CookieUtils.removeAll();
        setRoleFeatureList([]);
        window.location.href = "/login";
      } else {
        throw new Error(res?.error || "Logout failed");
      }
    } catch (error) {
      console.error("Logout error:", error);
      setErrorMessage("Something went wrong while logging out");
      setTimeout(() => {
        setErrorMessage("");
        setLoading(false);
        window.location.reload();
      }, 3000);
    }
  };

  const onPasswordChange = () => {
    CookieUtils.set("passwordChangeReason", "change_password");
    navigate("/forgot-password");
  };

  const options = [
    { option: "Change password", icon: PasswordIcon, action: onPasswordChange },
    { option: "Logout", icon: LogoutIcon, action: onUserLogout },
  ].filter(Boolean);

  const initials =
    username !== ""
      ? username
          .split(" ")
          .map((word) => word?.charAt(0)?.toUpperCase())
          .join("")
      : "--";

  if (loading || errorMessage) {
    return (
      <div className={styles.spinnerOverlay}>
        {errorMessage ? (
          <div className={styles.errorBox}>{errorMessage}</div>
        ) : (
          <Spinner />
        )}
      </div>
    );
  }

  return (
    <div className={styles.navBar}>
      <img src={logowhite} className={styles.logo} alt="brand_logo" />

      <Dropdown style={{ paddingRight: "10px" }}>
        <Dropdown.Toggle className={styles.dropdown}>
          <div className={styles.avatar}>{initials}</div>
        </Dropdown.Toggle>
        <Dropdown.Menu className={styles.menu}>
          <Dropdown.Item href="" className={styles.menu_header}>
            {username}
          </Dropdown.Item>

          <Dropdown.Divider className={styles.divider} />

          {options.map((item, index) => (
            <div key={index}>
              <Dropdown.Item
                onClick={item.action}
                className={
                  item.option === "Logout"
                    ? `${styles.menu_item} ${styles.textRed}`
                    : styles.menu_item
                }
              >
                {item.icon && (
                  <img
                    src={item.icon}
                    height={16}
                    width={16}
                    alt="menu_icon"
                    style={{ marginRight: "10px" }}
                  />
                )}
                {item.option}
              </Dropdown.Item>
              {index < options.length - 1 && (
                <Dropdown.Divider className={styles.divider} />
              )}
            </div>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default Header;
